module.exports = __webpack_public_path__ + "img/hackathon_varenne.809674fb.jpg";